export const ActionType = {
    Presence: 'PRESENCE',
    User: 'USER',
    Checkin: 'CHECKIN',
    Alarm: 'ALARM',
};
